const criar = (vm) => {
    let doc = new vm.$JsPDF('l', 'pt');
    vm.entradas = vm.$utils.exportaPdf.trataEntrada(vm.entradas);
    vm.$utils.exportaPdf.adicionaLogos(doc, vm.nomeImagemParceiro)

    function _configCampo (campo, valor, indexEntrada) {
      if (!valor && valor !== '0') return 'Não Avaliado';
      for(let descricaoIndex in vm.descricoes.items){
        if(descricaoIndex == campo) {
          if(vm.descricoes.items[descricaoIndex].prefixo != null) {
            valor = vm.descricoes.items[descricaoIndex].prefixo+" "+valor
          }
          if(vm.descricoes.items[descricaoIndex].sufixo != null) {
            valor += " "+vm.descricoes.items[descricaoIndex].sufixo
          }
          return valor
        }
      }
      return valor
    }

    const colunaNames = vm.entradas.map(el => el.nome);

    let camposEntrada = ['nome', 'dataD1', 'dataDZ', 'pesoInicialKg', 'pesoFinalKg', 'valorGadoCIF', 'custeioMensal', 'rendimentoDeCarcacaDoAbate', 'precoVendaLivre', 'estagioNegocio']
    let entrada = vm.$utils.exportaPdf.geraTabela(vm.entradas, camposEntrada, vm.pegarDescricao, _configCampo, colunaNames)
    let camposResultados = ['pesoEntradaArroba', 'pesoSaidaArroba', 'pesoSaidaKg', 'ganhoDePesoKG', 'ganhoDePesoArroba', 'cicloProdutivoMeses', 'cicloProdutivoDias', 'gmdKgD', 'gmdKgDComparativo', 'ganhoCarcacaKgd', 'rendimentoGanho', 'diasParaGanhar1Arroba', 'quantidadeArrobaGanhasCabecaMes', 'custoArrobaEntradaMagra', 'custoArrobaProduzida', 'custoArrobaVendida', 'pontoEquilibrioCusteio', 'pontoEquilibrioValorGado', 'pontoEquilibrioArrobaVendidaLivre', 'lucroLiquido', 'lucroLiquidoCabComparativo', 'lucratividadeOperacao', 'rentabilidadeOperacao', 'taxaMensalCapitalInvestidoGado']
    let resultados = vm.$utils.exportaPdf.geraTabela(vm.resultados, camposResultados, vm.pegarDescricao, _configCampo, colunaNames)

    let estiloColuna = {
      halign: 'right',
      valign: 'midle',
      textColor: 0,
      columnWidth: parseInt(550 / vm.lista.length),
      fontSize: 10,
      font: "helvetica",
    }
    let numeroPagina = 0;
    let options = {
      theme: 'striped',
      styles: {
        overflow: 'linebreak'
      },
      startY: 85,
      margin: {top: 30},
      drawCell: function (row, data) {
        if (row.text.length && row.text[0].replace(/[^0-9-]/g, '')) {
          let isComparativo = false;
          data.row.raw.forEach(el => {
            if (el.includes('comparativo')) isComparativo = true;
          })
          const text = row.text[0].replace(/[^0-9-]/g, '');
          if (isComparativo && text !== '-') {
            text.includes('-') ? doc.setTextColor('#FF3348') : doc.setTextColor('#54B07D');
          }
        }
      },
      addPageContent: function (data) {
        doc.setFontSize(10);
        if (numeroPagina !== doc.internal.getNumberOfPages()) {
          numeroPagina = doc.internal.getNumberOfPages()
          doc.text(40, 570, String(numeroPagina))
          doc.text(660, 570, 'Powered by Rancho Soluções');
        }
      },
      headerStyles: {
        fillColor: 255,
        textColor: 0,
        halign: 'right'
      },
      columnStyles:{
        0: {
          columnWidth: 200,
          fontStyle: 'bold',
          fillColor: [25, 150, 190],
          lineColor: [25, 150, 190],
          textColor: 255,
          fontSize: 10,
          font: "helvetica",
        },
        1: estiloColuna,
        2: estiloColuna,
        3: estiloColuna,
        4: estiloColuna,
        5: estiloColuna
      }
    };


    doc.setFontSize (14)
    doc.setFontType ("bold")
    doc.text ('Relatório (Comparativo Pasto - Simulação Básica)',250,50)

    let entradaPy = 165
    doc.centerText('Informações Produtivas e Financeiras', entradaPy);
    doc.setFontType ("normal")
    doc.setFontSize (9)
    doc.setTextColor(230,230,231)
    doc.centerText('_________________________________________________', entradaPy + 5);
    options.startY = entradaPy + 25;
    doc.autoTable(entrada.colunas, entrada.linhas, options);

    doc.addPage()
    // RESULTADOS
    let resultadosPy = 40
    doc.setFontSize (14)
    doc.setTextColor(0)
    doc.setFontType ("bold")
    doc.centerText('Resultados Produtivos e Econômicos', resultadosPy);
    doc.setFontType ("normal")
    doc.setFontSize (9)
    doc.setTextColor(230,230,231)
    doc.centerText('________________________________________________________________________', resultadosPy + 5);
    options.startY = resultadosPy + 25;
    doc.autoTable(resultados.colunas, resultados.linhas, options);

    return doc
}

export default {
    criar
}



// WEBPACK FOOTER //
// ./src/services/relatorio/comparativo/pasto/basico.js